import { IAgentInput, IQueryConfigArgs } from "../../common/types";
import { db, collectionWithArgs } from "./firestoreService";
import { COLLECTION_AGENTS } from "./firebaseConstants";

export function fetchAgentsFromFirestore(args?: IQueryConfigArgs[]) {
  const ref = db.collection(COLLECTION_AGENTS);
  return collectionWithArgs(ref, args || []);
}
export function listenToAgentFromFirestore(id: string) {
  return db.collection(COLLECTION_AGENTS).doc(id);
}

export function addAgentToFirestore(doc: IAgentInput) {
  // const user = firebase.auth().currentYachit;
  return db.collection(COLLECTION_AGENTS).add({
    ...doc,
    createDate: new Date(),
    // createBy: user,
  });
}

export function updateAgentInFirestore(docId: string, doc: IAgentInput | any) {
  return db.collection(COLLECTION_AGENTS).doc(docId).update(doc);
}

export function activeToggleAgentInFirestore(docId: string, status: boolean) {
  return db.collection(COLLECTION_AGENTS).doc(docId).update({
    status,
  });
}

export function deleteAgentInFirestore(docId: string) {
  return db.collection(COLLECTION_AGENTS).doc(docId).delete();
}
